module.exports = __webpack_public_path__ + "img/card-offer-tomato.ee4fc959.png";